import type { ServiceResponse } from "../api.types";
import { privateAPI } from "../axios";
import type { IntakeDetails } from "./intakes.types";

export const getIntakeDetails = async (intakeId: string) => {
  const { data } = await privateAPI.get<ServiceResponse<IntakeDetails>>(
    `/intakes/${intakeId}`,
  );

  return data.data;
};
